import React, {Component} from 'react';
import AppGlobals from "./AppGlobals";
import PropTypes from 'prop-types';
import _ from 'lodash';

//  The active view instance
let viewInstance;

/**
 * Returns the currently active view
 * @return {*}
 */
export const getActiveView = () => {
    return viewInstance;
};

/**
 * Sets children as the global active view
 */
class ActiveView extends Component {

    static propTypes = {
        view: PropTypes.any
    };

    componentDidMount() {
        viewInstance = this.props.view;
        AppGlobals.set('activeView',_.isFunction(this.props.view) ? this.props.view() : this.props.view);
    }

    componentWillUnmount() {
        viewInstance = null;
        AppGlobals.remove('activeView');
    }

    render(){
        return React.Children.only(this.props.children);
    }

}


export default ActiveView;


// WEBPACK FOOTER //
// ./src/common/ActiveView.js